import SelectInput from "@builder/components/general/ConditionSelectInput";
import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import TextInput from "@builder/components/general/TextInput";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType, StockActions } from "@common/build/types";
import { useEffect, useState } from "react";

const getKeyByValue = (object: Record<string, any>, value: string): string | undefined => {
    return Object.keys(object).find(key => object[key] === value);
};

const op: Record<string, string> = {
    "Stock Received": StockActions.RECEIVED,
    "Inventory Re-count": StockActions.RECOUNT,
    Damage: StockActions.DAMAGE,
    Theft: StockActions.THEFT,
    Loss: StockActions.LOSS,
    "Restock Return": StockActions.RESTOCK
};

const AdjustInventory = () => {
    const dispatch = useAppDispatch();
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [isFixed, setFixed] = useState(actionStep?.action?.data.isFixed || false);
    const [amount, setAmount] = useState(actionStep?.action?.data.amount || "");
    const [selectedOption, setSelectedOption] = useState(getKeyByValue(op, actionStep?.action?.data.stockType) || "");

    const handleAmount = (value: string) => {
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            setAmount(value);
        }
    };

    useEffect(() => {
        const action = {
            type: isFixed ? ActionType.ADJUST_INVENTORY : ActionType.SHOW_ADJUST_INVENTORY,
            data: { isFixed, amount, stockType: op[selectedOption] }
        };

        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, isFixed, amount, selectedOption]);

    return (
        <div className="function-add-cart-note-wrapper">
            <OliverText text="How do you want to adjust inventory?" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper" onClick={() => setFixed(false)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Open adjust inventory" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText text="This will open the adjust inventory view" size="xs" weight="light" translatePrefix="popup.actionBuilder." />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={!isFixed} label="" value="" custom={false} />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => setFixed(true)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Adjust inventory by fixed amount" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText
                            text="This will adjust inventory a fixed amount"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={isFixed} label="" value="" custom={false} />
                </div>
                {isFixed ? (
                    <>
                        <SelectInput
                            layout="column"
                            value={selectedOption}
                            callback={setSelectedOption}
                            options={Object.keys(op)}
                            placeholder="Select stock action"
                        />
                        <TextInput
                            callback={handleAmount}
                            value={amount}
                            className="actions-tab-input"
                            placeholder="How much quantity do you want to add?"
                        />
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default AdjustInventory;
